import { Link } from "react-router-dom";
import { Clock, ShieldCheck, IdCard, Trees, ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const FACTS = [
  { icon: Clock, k: "Tur süresi", v: "2 saat" },
  { icon: ShieldCheck, k: "Dahil", v: "Motor, ekipman ve kıyafetler" },
  { icon: Trees, k: "Paket bedeli", v: "5.000 TL" },
  { icon: IdCard, k: "Şart", v: "Geçerli A, A1 veya A2 ehliyet" },
];

export const TourInfo = () => (
  <section id="tur" data-testid="tour-section" className="relative overflow-hidden bg-brand">
    <div className="mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-2">
      <div className="px-5 py-20 md:px-8 md:py-28 lg:pr-16">
        <Reveal>
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.25em] text-white/80">Enduro Tur</p>
          <h2 className="font-display text-5xl uppercase leading-[0.9] text-white md:text-7xl">Motorun yok mu? Sorun değil.</h2>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-white/90 md:text-lg">
            Çekmeköy Ormanları'nın doğal parkurlarında, profesyonel rehberler eşliğinde unutulmaz bir enduro deneyimi. Tesise ait motor, ekipman ve kıyafetlerle güvenle sür.
          </p>
        </Reveal>
        <div className="mt-10 grid grid-cols-1 border-l border-t border-white/25 sm:grid-cols-2">
          {FACTS.map((f, i) => (
            <Reveal key={f.k} delay={i * 0.08} className="border-b border-r border-white/25 p-5">
              <div data-testid={`tour-fact-${i}`}>
                <f.icon className="h-6 w-6 text-white" strokeWidth={1.75} />
                <p className="mt-4 text-xs font-semibold uppercase tracking-[0.2em] text-white/70">{f.k}</p>
                <p className="mt-1 font-display text-2xl uppercase leading-tight text-white">{f.v}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Link to="/enduro-tur" data-testid="tour-booking-btn" className="group mt-10 inline-flex items-center gap-3 bg-black px-8 py-4 font-bold uppercase tracking-wider text-white transition-colors hover:bg-white hover:text-black">
          Tur detayları <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
        </Link>
      </div>
      <div className="relative min-h-[420px]">
        <img src="/photos/cam-ziplama.jpg" alt="Çamların önünde toz kaldırarak zıplayan enduro sürücüsü" loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
      </div>
    </div>
  </section>
);
